import Aviator from "aviator";
import { match } from "ramda";
import { Maybe } from "true-myth";

export function decodePreviewLink(
  requestValue: string | undefined
): Maybe<string> {
  if (requestValue) {
    const decodedPreviewLink = atob(requestValue);
    if (
      match(
        /^https:\/\/res(-\d)?.cloudinary.com\/upserve(-\w*)*\/image\/upload\/.*$/,
        decodedPreviewLink
      ).length >= 1
    ) {
      return Maybe.of(decodedPreviewLink);
    }
  }
  return new Maybe.Nothing();
}

export function getPreviewBannerUrl(
  request = Aviator.getCurrentRequest()
): Maybe<string> {
  const { banner_preview: bannerPreview } = request.queryParams;
  return decodePreviewLink(bannerPreview);
}

export function getPreviewLogoUrl(
  request = Aviator.getCurrentRequest()
): Maybe<string> {
  const { logo_preview: logoPreview } = request.queryParams;
  return decodePreviewLink(logoPreview);
}
